import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const GlobalFunnelReport = lazy(() =>
  import("@scenes/GlobalFunnelReports/GlobalFunnelReport/GlobalFunnelReport").then((module) => ({
    default: module.GlobalFunnelReport,
  }))
);

export const globalFunnelReportNRO: NavigationRoutingObject = {
  Component: GlobalFunnelReport,
  noKnockoutFallback: true,
  componentFeatureFlippers: [],
  section: "analytics",
  heading: (t: I18nT<"dashboard-navigation">) => t("funnel-report-nro-heading", "Funnel Report"),
  pageNameForTracking: () => "Funnel Report",
  getDeveloperNavigationAllowed: ({ featureOn, isImpersonating, hasPermission }) => {
    const userHasViewReportingPermission = hasPermission("appGroup", {
      permission: "viewReporting",
    });
    return featureOn("global_funnel_reports") && (isImpersonating || userHasViewReportingPermission);
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/funnel_reports/:appGroupId",
};
